import { z } from 'zod'

const booleanSearchParam = z
  .preprocess((value) => value === true || value === 'true', z.boolean())
  .catch(false)

const internshipProgramRequestFiltersSchema = z.object({
  search: z.string().optional(),
  graded: z.boolean().optional(),
  hasRecords: z.boolean().optional(),
  notDone: z.boolean().optional(),
})

export const internshipProgramSearchSchema = internshipProgramRequestFiltersSchema.extend({
  search: z.string().max(200).optional().catch(undefined),
  graded: booleanSearchParam,
  hasRecords: booleanSearchParam,
  notDone: booleanSearchParam,
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .int()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(10),
  sortBy: z.enum(['title', 'planned', 'done', 'left', 'progress']).catch('title'),
  sortDirection: z.enum(['asc', 'desc']).catch('asc'),
})

export type InternshipProgramSearch = z.infer<typeof internshipProgramSearchSchema>

export const defaultInternshipProgramSearch = internshipProgramSearchSchema.parse({})
